import request from "root/js/request";

export const getAdvertCampaignsOzon = async ({ wb_api_key_ids, ...rest }) => {
  const response = await request({
    url: "/ozon_analytics/advert_campaigns/",
    method: "get",
    params: {
      wb_api_key_ids,
      ...rest,
    },
  });
  return response.data;
};
